import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/o/$orgId/multiview')({
  loader: () => ({
    crumb: 'Multiview',
  }),
})
